module.exports = __webpack_public_path__ + "img/p1.d48f45d1.png";